var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"i",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }